<template>
  <div :id="key_id" class="box box-combination" :active="localSelected">
    <div class="box-content">

        <div class="placement-info--wrapper">
          <placement-info-site v-for="(placement, index) in combination.placements "
                          :placement="placement"
                          :main_group="main_group"
                          :index="index"
                          :key="index"
          />
        </div>
        <div class="combination-summary">
          <div class="combination-price">
            <template v-if="combination.price !== 0">
              <CombinationPrice
                :price="combination.price"
                :discount="discount_precalc"
                :discount_type="discount_type"
                direction="col"
                :currency="currency"
              ></CombinationPrice>


            </template>
          </div>
          <div v-if="!readonly" @click="choose_combination" :class="button_css"></div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import PlacementInfoSite from "./PlacementInfoSite";
import CombinationPrice from "./CombinationPrice";
export default{
  components: {CombinationPrice, PlacementInfoSite },
  props: {
    combination: {
      type: Object,
      default: {
        price: 0,
        has_shared: false,
        rooms_quantity: 1,
        selected: false,
        placements: [
          {
            placement: {
              attributes: {}
            },
          },
        ],

      },
    },
    main_group: Boolean,
    index: Number,
    selected: Boolean,
    readonly: Boolean,
    discount: Number,
    discount_type: String,
    currency: String,
  },
  data(){
    return {
      localCombination: this.combination,
      localSelected: this.selected,
    }
  },
  computed:{
    key_id(){
      return `combination-${this.index}`
    },
    button_css(){
      let active = this.localSelected ? 'active' : '';
      return `btn-radio ${active}`
    },
    person_quantity() {
      return this.localCombination.person_quantity;
    },
    discount_precalc(){
      if (this.discount_type == 'fixed_value') {
        if (this.main_group){
          return this.discount * this.localCombination.person_quantity;
        } else {
          return 0;
        }
      } else {
        return this.discount;
      }
    },
  },
  watch:{
    combination(new_value){
      // console.log('combination changed')
      this.$set(this,'localCombination', new_value);
    },
    selected(new_value){
      this.$set(this, 'localSelected', Boolean(new_value));
    },

  },
  // beforeUpdate() {
  //   this.$set(this, 'localSelected', Boolean(this.selected));
  // },
  methods:{
    choose_combination(){
      // console.log('click!!')
      this.$set(this, 'localSelected', true);
      this.$emit('select', this.index, this.combination);
    }
  }
}
</script>